import styled from 'styled-components'

export default styled.h1`
  font-size: 5.078125vw;
  letter-spacing: -0.1015625vw;
  line-height: 110%;
  color: #${props => (props.color ? props.color : 'inherit')};

  @media (max-width: 40em) {
    font-size: 40px;
  }

  @media (min-width: 48em) and (max-width: 60em) {
    font-size: 65px;
  }
`
